import { Injectable } from '@angular/core';
import { HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { PostmethodService } from '../../app-config/postmethod.service';

@Injectable({
  providedIn: 'root',
})
export class VNMappingService {
  private apiUrl = environment.baseUrl;

  constructor(private ws: PostmethodService) {}


  getDropDownData(): Observable<any> {
    return this.ws.wsGet(`${this.apiUrl}virtualNumber/vnMappingMaster`);
  }

  getVirtualNumbers(queryParams:any): Observable<any> {
    return this.ws.wsGet(`${this.apiUrl}virtualNumber/list?`+ queryParams);
  }

  createVirtualNumber(data: any): Observable<any> {

    return this.ws.wsPost(data, `${this.apiUrl}virtualNumber/vnMapping`);
  }

  updateVirtualNumber(id: number, data: any): Observable<any> {

    return this.ws.wsPost(data, `${this.apiUrl}virtualNumber/vnMapping?id=${id}`);
  }

  createVirtualNumberIVR(data: any): Observable<any> {
    return this.ws.wsPost(data, `${this.apiUrl}virtualNumber/vnMappingIvr`);
  }

  updateVirtualNumberIVR(id: number, data: any): Observable<any> {
    return this.ws.wsPost(data, `${this.apiUrl}virtualNumber/vnMappingIvr?id=${id}`);
  }
}
